import { all, call, put, takeLatest } from 'redux-saga/effects';
import { fetchFieldMappings, updateFieldMappings } from '../routines';
import { request } from '../../common/util/RestClient';
import envConfig from '../../config';
import SUCCESS_MESSAGES from '../../common/constants/SuccessMessagesConstants';

export function* fetchFieldMappingsSaga({ payload }) {
  const format = payload.format || 'object';
  const { level } = payload;
  if (!level) throw new TypeError('Level cannot be null or undefined');
  try {
    const URL = `${envConfig.APIG_URL}core/field-mappings?format=${format}&level=${payload.level}`;
    const response = yield call(request, URL);
    yield put(fetchFieldMappings.success({ response, level }));
  } catch (error) {
    yield put(fetchFieldMappings.failure({ error, level }));
  }
}

export function* updateFieldMappingsSaga({ payload }) {
  try {
    const URL = `${envConfig.APIG_URL}core/field-mappings?level=${payload.level}`;
    const config = {
      method: 'PATCH',
      payload: { data: payload.data },
    };
    const response = yield call(request, URL, config);
    yield put(
      updateFieldMappings.success({
        response,
        successMessage: SUCCESS_MESSAGES.UPDATE_GLOBAL_MAPPING,
      })
    );
    yield put(fetchFieldMappings.trigger({ level: payload.level }));
  } catch (err) {
    yield put(
      updateFieldMappings.failure({ error: err, level: payload.level })
    );
  }
}

export default function* root() {
  yield all([takeLatest(fetchFieldMappings.TRIGGER, fetchFieldMappingsSaga)]);
  yield all([takeLatest(updateFieldMappings.TRIGGER, updateFieldMappingsSaga)]);
}
